const TAG_DEFAULT = 'div';
export default function computeTagName(tag, defaultTag = TAG_DEFAULT) {
  let trimmedTag, trimmedDefaultTag;
  return !!tag && ('string' === typeof tag) && !!(trimmedTag = tag.trim()) ?
    trimmedTag :
    (
      !!defaultTag && ('string' === typeof defaultTag) && !!(trimmedDefaultTag = defaultTag.trim()) ?
        trimmedDefaultTag :
        TAG_DEFAULT
    );
}
